import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

import auth from '@/store/auth'
import applications from '@/store/applications'
import clockIn from '@/store/clockIn';
import tutors from '@/store/tutors';
import booths from '@/store/booths';
import students from '@/store/students';
import courses from '@/store/courses';
import lessons from '@/store/lessons'
import waitings from '@/store/waitings'
import master from '@/store/master';
import schedules from '@/store/schedules'
import timesheets from '@/store/timesheets';
import groups from '@/store/groups';
import mails from '@/store/mails';
import evaluations from '@/store/evaluations';
import mypage from '@/store/mypage'
import deadlines from '@/store/deadlines';
import extras from '@/store/extras';
import { RootState } from '@/store/types';

Vue.use(Vuex);

const store = new Vuex.Store<RootState>({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth,
    applications,
    clockIn,
    tutors,
    students,
    booths,
    schedules,
    timesheets,
    courses,
    lessons,
    waitings,
    mails,
    master,
    mypage,
    groups,
    evaluations,
    deadlines,
    extras,
  },
  plugins: [createPersistedState({
    key: 'tutorial_english-at',
    paths: ['auth'],
    storage: window.sessionStorage,
  })],
});

if (module.hot) {
  // ホットリロードで認証情報を削除しないように
  module.hot.accept(['./auth'], () => {
    store.hotUpdate({
      modules: {
        // @ts-expect-error 型チェック不要部分
        auth: auth.default,
      },
    })
  })
}

export default store
